import { render, staticRenderFns } from "./CCTable.vue?vue&type=template&id=a4574b10"
import script from "./CCTable.vue?vue&type=script&lang=js"
export * from "./CCTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports